// extracted by mini-css-extract-plugin
export default {"main":"Topics_main__5+inc","left":"Topics_left__uZXmF","right":"Topics_right__l2qrr","footer":"Topics_footer__9ZCgO","prev":"Topics_prev__eITL7","next":"Topics_next__KAe7D"};